import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';

import CompanyDetails from './CompanyDetails';
import ApplicationSettings from './ApplicationSettings';
import CompanyMetrics from './CompanyMetrics';
import CompanyViewSelector from '../../../components/CompanyViewSelector';

import * as CompanyManagementActions from '../../../actions/companyManagementActions';

const SettingsContainer = ({
    companyCreate,
    currentUser,
    fetchCompanyMetrics,
    handleBackClick,
    selectedCompany,
    setCompanyCreate,
    setSelectedCompany,
    ...props
}) => {

    const [view, setView] = useState('company settings');

    useEffect(() => {
        const init = async () => {
            await fetchCompanyMetrics(selectedCompany.id);
        };

        if (currentUser.isSuperUser !== null && selectedCompany?.id ) init();
    }, [selectedCompany]);

    const renderView = () => {
        if (view === 'company settings') {
            return (
                <CompanyDetails
                    companyCreate={companyCreate}
                    handleBackClick={handleBackClick}
                    selectedCompany={selectedCompany}
                    onClose={() => { setCompanyCreate(false); }}
                    setSelectedCompany={setSelectedCompany}
                />
            );
        } else if (view === 'application settings') {
            return (
                <ApplicationSettings
                    handleBackClick={handleBackClick}
                    selectedCompany={selectedCompany}
                />
            );
        } else if (view === 'company metrics') {
            return (
                <CompanyMetrics
                    handleBackClick={handleBackClick}
                />
            );
        }
    };

    return (
        <div>
            <div>
                <CompanyViewSelector
                    currentUser={currentUser}
                    view={view}
                    handleChangeView={setView}
                />
            </div>
            {renderView()}
        </div>
    );
};

const mapDispatchToProps = ({
    ...CompanyManagementActions
});

export default connect(null, mapDispatchToProps)(SettingsContainer);
